import { styled, TableCell as MuiTableCell } from '@ethings/ui-toolkit';
import { TableCellProps } from '@mui/material';
import { SxProps, unstable_styleFunctionSx as unstableStyleFunctionSx } from '@mui/system';
import { FC, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  'data-testid'?: string;
  stopClickPropagation?: boolean;
  sx?: SxProps;
  align?: TableCellProps['align'];
}

const StyledTableCell = styled(MuiTableCell)<{ cellsx?: SxProps }>(({ cellsx }) => {
  return {
    ...(unstableStyleFunctionSx({ sx: cellsx } as never) as Record<string, unknown>),
  };
});

export const TableCell: FC<Props> = ({ children, sx, stopClickPropagation, align, ...props }) => {
  return (
    <StyledTableCell
      component='div'
      onClick={stopClickPropagation ? (e) => { e.stopPropagation(); } : undefined}
      align={align}
      cellsx={{
        fontSize: '1rem',
        verticalAlign: 'middle',
        '@media (max-width: 600px)': {
          display: 'block',
          width: '100%',
          padding: '8px 16px !important',
          borderBottom: 'none',
          textAlign: align === 'right' ? 'center' : align,
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </StyledTableCell>
  );
};
